import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Phase C (2026-08-20) — read csrf_token cookie for double-submit CSRF.
function _readCookie(name) {
  const parts = document.cookie.split("; ");
  const found = parts.find((p) => p.startsWith(name + "="));
  return found ? decodeURIComponent(found.slice(name.length + 1)) : null;
}

const _UNSAFE = new Set(["post", "put", "patch", "delete"]);

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("st_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const m = (config.method || "get").toLowerCase();
  if (_UNSAFE.has(m)) {
    const csrf = _readCookie("csrf_token");
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Token invalid/expired — drop session
      localStorage.removeItem("st_token");
      localStorage.removeItem("st_user");
      if (!window.location.pathname.endsWith("/login")) {
        sessionStorage.setItem("st_session_expired", "1");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return JSON.stringify(d);
}

export default api;
